<template>
  <div>
    <NicknameTextField
      v-model="nickname"
      :isHiddenRequiredSign="false" 
    />
  </div>
</template>

<script>
import NicknameTextField from '@/components/Molecules/NicknameTextField';

export default {
  name: 'RegistrationProfileSetting',
  components: {
    NicknameTextField,
  },
  props: ['value'],
  computed: {
    // hide props
    nickname: {
      get() {
        return this.value.nickname;
      },
      set(nickname) {
        this.updateValue({ nickname });
      }
    },
    // calculate and notify parent of new property
    isValid() {
      return this.nickname !== '';
    },
  },
  watch: {
    // calculate and notify parent of new property
    isValid: {
      handler(isValid) {
        this.updateValue({ isValid });
      },
      immediate: true,
    }
  },
  methods: {
    updateValue(diff) {
      let newValue = {...this.value, ...diff};
      this.$emit('input', newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/signup-email.scss';
</style>
